export default __webpack_public_path__ + "static/media/card1.c6d44b85.png";